import { addDays, differenceInYears, format, parseISO, subYears } from 'date-fns';
import { IHealthInsuranceConfig } from '@/types';

export const MAX_MEMBER_AGE_YEARS = 120;

export type TAgeBand = 'adult' | 'child';

export const parseDob = (dob: string): Date => parseISO(dob);

export const toDateOnly = (dob?: string): string => {
  if (!dob?.trim()) return '';
  const date = parseDob(dob);
  if (Number.isNaN(date.getTime())) return '';
  return format(date, 'yyyy-MM-dd');
};

export const isValidDob = (dob?: string): dob is string => {
  if (!dob?.trim()) return false;
  const date = parseDob(dob);
  return !Number.isNaN(date.getTime()) && date.getTime() <= Date.now();
};

export const getAgeFromDob = (dob?: string): number =>
  isValidDob(dob) ? differenceInYears(new Date(), parseDob(dob)) : NaN;

export const getDobRange = (
  band: TAgeBand,
  config?: IHealthInsuranceConfig,
): { fromDate: Date; toDate: Date } => {
  const today = new Date();

  if (band === 'child') {
    const maxAge = config?.ageConstraints?.child?.max?.value ?? MAX_MEMBER_AGE_YEARS;
    const minAge = config?.ageConstraints?.child?.min?.value ?? 0;
    return {
      fromDate: addDays(subYears(today, maxAge), 1),
      toDate: subYears(today, minAge),
    };
  }

  const minAge = config?.ageConstraints?.adult?.min?.value ?? 0;
  return {
    fromDate: subYears(today, MAX_MEMBER_AGE_YEARS),
    toDate: subYears(today, minAge),
  };
};
